import { render, staticRenderFns } from "./RestaurantActions.vue?vue&type=template&id=64144ae2"
import script from "./RestaurantActions.vue?vue&type=script&lang=js"
export * from "./RestaurantActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports